"use strict";

var _a, _b, _c, _d;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonStyle = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = require("styled-components");

var typography_1 = require("../../../styles/typography");

var state_1 = require("../../../styles/utils/state");

var types_1 = require("../types");

var variantStyles_1 = require("./variantStyles");

var BUTTON_HEIGHT = (_a = {}, _a[types_1.Size.SMALL] = '24px', _a[types_1.Size.NORMAL] = '32px', _a[types_1.Size.LARGE] = '40px', _a);
var BUTTON_TEXT_SIZE = (_b = {}, _b[types_1.Size.SMALL] = '14px', _b[types_1.Size.NORMAL] = '14px', _b[types_1.Size.LARGE] = '16px', _b);
var CONTENTS_POSITION = (_c = {}, _c[types_1.Align.START] = 'flex-start', _c[types_1.Align.LEFT] = 'flex-start', _c[types_1.Align.CENTER] = 'center', _c[types_1.Align.RIGHT] = 'flex-end', _c[types_1.Align.END] = 'flex-end', _c);
var BUTTON_DESIGN = (_d = {}, _d[types_1.Variant.CALL_TO_ACTION] = variantStyles_1.callToActionStyle, _d[types_1.Variant.FILLED] = variantStyles_1.filledStyle, _d[types_1.Variant.OUTLINED] = variantStyles_1.outlinedStyle, _d[types_1.Variant.OUTLINED_COLOR] = variantStyles_1.outlinedColorStyle, _d[types_1.Variant.FLAT] = variantStyles_1.flatStyle, _d[types_1.Variant.FLAT_COLOR] = variantStyles_1.flatColorStyle, _d[types_1.Variant.DASH] = variantStyles_1.dashStyle, _d[types_1.Variant.OUTLINED_HOVER_COLOR] = variantStyles_1.outlinedHoverColorStyle, _d[types_1.Variant.OUTLINED_TEXT_COLOR] = variantStyles_1.outlinedTextColorStyle, _d);

exports.buttonStyle = function (_a) {
  var _b = _a.size,
      size = _b === void 0 ? types_1.Size.NORMAL : _b,
      _c = _a.align,
      align = _c === void 0 ? types_1.Align.CENTER : _c,
      _d = _a.variant,
      variant = _d === void 0 ? types_1.Variant.CALL_TO_ACTION : _d,
      responsive = _a.responsive;
  var height = BUTTON_HEIGHT[size];
  var fontSize = BUTTON_TEXT_SIZE[size];
  var width = responsive ? '100%' : 'auto';
  var style = BUTTON_DESIGN[variant];
  var contentPosition = CONTENTS_POSITION[align];
  return styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\tword-break: initial;\n\t\tfont-family: ", ";\n\t\tfont-size: ", ";\n\t\theight: ", ";\n\t\twidth: ", ";\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: ", ";\n\t\tborder-radius: 4px;\n\t\tborder-style: solid;\n\t\tborder-width: 1px;\n\t\toutline: 0;\n\t\tpadding: 0 8px;\n\t\ttransition: all 0.2s ease-in-out;\n\t\t", ";\n\t\t", ";\n\t\t", ";\n\t\t@media (hover: none) {\n\t\t\ttransition: all 0.8s ease-in-out;\n\t\t}\n\t"], ["\n\t\tword-break: initial;\n\t\tfont-family: ", ";\n\t\tfont-size: ", ";\n\t\theight: ", ";\n\t\twidth: ", ";\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: ", ";\n\t\tborder-radius: 4px;\n\t\tborder-style: solid;\n\t\tborder-width: 1px;\n\t\toutline: 0;\n\t\tpadding: 0 8px;\n\t\ttransition: all 0.2s ease-in-out;\n\t\t", ";\n\t\t", ";\n\t\t", ";\n\t\t@media (hover: none) {\n\t\t\ttransition: all 0.8s ease-in-out;\n\t\t}\n\t"])), typography_1.fontFamilies.highlight, fontSize, height, width, contentPosition, state_1.ifNotDisabled(state_1.always('cursor', 'pointer')), state_1.always('text-decoration', 'none'), style);
};

var templateObject_1;